import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de produccion - Alistamiento material empaque
 **/

class CustomAlistamientoMaterial extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                           = this.initForm.bind(this);
        this.successDatosFicha                  = this.successDatosFicha.bind(this);
        this.succesTbMaterialEmpaque            = this.succesTbMaterialEmpaque.bind(this);
        this.gridOptionsTbMaterialEmpaque       = Object.assign({}, this.gridOptions);
        this.setButtonAlistar                   = this.setButtonAlistar.bind(this);
        this.setChangeButtonAlistarclick        = this.setChangeButtonAlistarclick.bind(this);    
        this.succesButtonAlistar                = this.succesButtonAlistar.bind(this);
        this.recargarTbMaterialEmpaque          = this.recargarTbMaterialEmpaque.bind(this); 
        this.terminarMaterialEmpaque            = this.terminarMaterialEmpaque.bind(this);   
        this.dataTable = [];
        this.verFormula                         = this.verFormula.bind(this);
        this.successVerFormula                  = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula              = Object.assign({}, this.gridOptions);
    }


    initForm() {
        console.log('CustomAlistamientoMaterial @version: 1.01.0054 @author: Juan David Nieto; @updateBy Sebastian Rios Echverri');
        this.getField('btnTerminar').setClick(this.terminarMaterialEmpaque);

        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '395-servicio_traer_datos_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
        let datos2 = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'porleer', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos2,
            success: this.succesTbMaterialEmpaque,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        // produccion_fichas_envasado_inicial_material_empaque-porleer prod-fichasenvasadoinicial
        /*this.generalFormat.nombre_accion = '395-Fichas_envasado_mat_Empq_x_leer'; 
        this.service.send(
            {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:body,
            success:this.succesTbMaterialEmpaque,
            error:this.error_,
            general: this.generalFormat,
            showMessage :false
            });*/

        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    successDatosFicha(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('lista_items_produccion').setVisible(true);
            this.getField('lista_items_produccion').setItemsFichas(data.model);
        }else{
            this.getField('lista_items_produccion').setVisible(false);
        }
    }


    succesTbMaterialEmpaque(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0) 
        {
            this.gridOptionsTbMaterialEmpaque['rowData']=[];
            this.getField('TbMaterialEmpaque').initData(this.gridOptionsTbMaterialEmpaque);
            this.getField('TbMaterialEmpaque').toggle(true);
            this.gridOptionsTbMaterialEmpaque['rowData'] = data.model;
            this.dataTable = data.model
            this.gridOptionsTbMaterialEmpaque.paginationPageSize = 100;
            let configCellcol = new Map();
            configCellcol.set('accion', {cellRenderer:this.setButtonAlistar, field:'Acción'});
            this.getField('TbMaterialEmpaque').initData(this.gridOptionsTbMaterialEmpaque, configCellcol);
            this.gridOptionsTbMaterialEmpaque.api.selectIndex(0, true, true);
        }else{ 
          this.getField('TbMaterialEmpaque').toggle(false);
          this.getField('fieldAlert').toggle(true,"No hay material de empaque","warning");
          this.dataTable = [];
        }
    }

    setButtonAlistar(props){
        let button = document.createElement("input");
        button.onclick = () => this.setChangeButtonAlistarclick(props.data);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type","button");
        button.setAttribute("value","Abastecer");
        return this.createElementJaivana(button); 
    }

    setChangeButtonAlistarclick(data){
        let datos = {
            datos:{
                id: data.id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'leido', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.succesButtonAlistar,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = "395-Permite_modificar_el_parametro_leido=1_del_registro"; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'PUT',
            body:body,
            success:this.succesButtonAlistar,
            error:this.error_,
            general: this.generalFormat
        });*/
    }

    succesButtonAlistar(response){
        if(response.estado_p === 200){
            this.getField('fieldAlert').toggle(true,"Se actualizo de forma correcta","success");
            this.recargarTbMaterialEmpaque();
        }
    }
    recargarTbMaterialEmpaque(){
        let datos = {
            datos: {
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'porleer', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesTbMaterialEmpaque,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '395-Fichas_envasado_mat_Empq_x_leer'; 
        this.service.send(
            {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:body,
            success:this.succesTbMaterialEmpaque,
            error:this.error_,
            general: this.generalFormat,
            showMessage :false
            });*/
    }

    terminarMaterialEmpaque(){
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);

        if(this.dataTable.length > 0){
            this.getField('fieldAlert').toggle(true,"Aun faltan items por recibir","error");
        }else{
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                    proceso_id:this.getField('proceso_id').getValue(),
                    actividad_id:this.getField('actividad_id').getValue(),
                    actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                }
            }
            this.getField('btnTerminar').setDisabled(true);

            this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'alistamiento', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = "395-Permite_terminar_y_pasar_etapa_aislamiento"; 
            this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'PUT',
                body:body,
                success:this.successCloseEstage,
                error:this.error_,
                general: this.generalFormat
            });*/
        }
        
    }

}

export default CustomAlistamientoMaterial; 
FormJaivana.addController("prod-alistamientomaterialemp",CustomAlistamientoMaterial);
